 export const ifsc = [
    {
     "name": "STATE BANK OF INDIA",
     "ifsc": "SBIN0000001"
    },
    {
     "name": "IndusInd Bank",
     "ifsc": "INDB0000001"
    },
    {
     "name": "ICICI Bank",
     "ifsc": "ICIC0000011"
    },
    {
     "name": "HDFC Bank",
     "ifsc": "HDFC0999999"
    },
    {
     "name": "Axis Bank",
     "ifsc": "UTIB0000248"
    },
    {
     "name": "Punjab National Bank",
     "ifsc": "PUNB0244200"
    },
    {
     "name": "BARODA UP BANK",
     "ifsc": "BARB0BUPGBX"
    },
    {
     "name": "UNION BANK OF INDIA",
     "ifsc": "UBIN0550451"
    },
    {
     "name": "AIRTEL PAYMENTS BANK",
     "ifsc": "AIRP0000001"
    },
    {
     "name": "S",
     "ifsc": "UCBA0000001"
    },
    {
     "name": "INDIAN BANK",
     "ifsc": "IDIB000L003"
    },
    {
     "name": "BANK OF INDIA",
     "ifsc": "BKID0000150"
    },
    {
     "name": "CANARA BANK",
     "ifsc": "CNRB0000002"
    },
    {
     "name": "BANK OF BARODA",
     "ifsc": "BARB0NEHRUP"
    },
    {
     "name": "Kotak Mahindra Bank",
     "ifsc": "KKBK0RTGSMI"
    },
    {
     "name": "CENTRAL BANK OF INDIA",
     "ifsc": "CBIN0281107"
    },
    {
     "name": "INDIAN OVERSEAS BANK",
     "ifsc": "IOBA0000002"
    },
    {
     "name": "BANDHAN BANK",
     "ifsc": "BDBL0001118"
    },
    {
     "name": "ARYAVART BANK",
     "ifsc": "BKID0ARYAGB"
    },
    {
     "name": "FINO PAYMENTS BANK",
     "ifsc": "FINO0000001"
    },
    {
     "name": "MIZORAM RURAL BANK",
     "ifsc": "SBIN0RRMIGB"
    },
    {
     "name": "UTTAR BIHAR GRAMIN BANK",
     "ifsc": "CBIN0R10001"
    },
    {
     "name": "PRIYADARSHANI NAGARI SAHAKARI BANK",
     "ifsc": "KKBK0PNSB01"
    },
    {
     "name": "IDBI BANK",
     "ifsc": "IBKL0000039"
    },
    {
     "name": "Yes Bank",
     "ifsc": "YESB0000001"
    },
    {
     "name": "MANIPUR RURAL BANK",
     "ifsc": "PUNB0RRBMRB"
    },
    {
     "name": "TELANGANA GRAMEENA BANK",
     "ifsc": "SBIN0RRDCGB"
    },
    {
     "name": "JHARKHAND RAJYA GRAMIN BANK",
     "ifsc": "SBIN0RRVCGB"
    },
    {
     "name": "INDIA POST PAYMENTS BANK",
     "ifsc": "IPOS0000001"
    },
    {
     "name": "ZILA SAHAKARI BANK (GHAZIABAD)",
     "ifsc": "ZSBL0000001"
    },
    {
     "name": "CITY UNION BANK",
     "ifsc": "CIUB0000001"
    },
    {
     "name": "BANGIYA GRAMIN VIKASH BANK",
     "ifsc": "PUNB0RRBBGB"
    },
    {
     "name": "THE SURAT PEOPLES CO-OP BANK",
     "ifsc": "SPCB0251001"
    },
    {
     "name": "FINCARE SMALL FINANCE BANK",
     "ifsc": "FSFB0000001"
    },
    {
     "name": "NSDL PAYMENTS BANK",
     "ifsc": "NSPB0000002"
    },
    {
     "name": "THE NEW URBAN CO-OP BANK",
     "ifsc": "HDFC0CNUCBL"
    },
    {
     "name": "BANK OF MAHARASHTRA",
     "ifsc": "MAHB0000978"
    },
    {
     "name": "BANASKANTHA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "GSCB0BKD001"
    },
    {
     "name": "ETAWAH DISTRICT CO-OP BANK",
     "ifsc": "ICIC00ETAWH"
    },
    {
     "name": "THE GUJARAT STATE CO-OP BANK",
     "ifsc": "GSCB0000001"
    },
    {
     "name": "JALNA MERCHANTS CO-OP BANK",
     "ifsc": "HDFC0CJMCBL"
    },
    {
     "name": "FEDERAL BANK",
     "ifsc": "FDRL0000035"
    },
    {
     "name": "HSBC BANK",
     "ifsc": "HSBC0400002"
    },
    {
     "name": "KARNATAKA BANK",
     "ifsc": "KARB0000001"
    },
    {
     "name": "MAHARASHTRA GRAMEEN BANK",
     "ifsc": "MAHG0004000"
    },
    {
     "name": "RBL BANK",
     "ifsc": "RATN0000001"
    },
    {
     "name": "ADARSH CO-OP BANK (RAJASTHAN)",
     "ifsc": "HDFC0CADARS"
    },
    {
     "name": "PUNJAB AND SIND BANK",
     "ifsc": "PSIB0000001"
    },
    {
     "name": "PAYTM PAYMENTS BANK",
     "ifsc": "PYTM0123456"
    },
    {
     "name": "DAKSHIN BIHAR GRAMIN BANK",
     "ifsc": "PUNB0MBGB06"
    },
    {
     "name": "MADHYA PRADESH GRAMEEN BANK",
     "ifsc": "BKID0NAMRGB"
    },
    {
     "name": "COSMOS BANK",
     "ifsc": "COSB0000019"
    },
    {
     "name": "DEUSTCHE BANK",
     "ifsc": "DEUT0000PBC"
    },
    {
     "name": "BHAGINI NIVEDITA SAHAKARI BANK",
     "ifsc": "HDFC0CBNBNK"
    },
    {
     "name": "RAJKOT PEOPLES CO-OP BANK",
     "ifsc": "IBKL01642RP"
    },
    {
     "name": "SHREE KADI NAGARIK SAHAKARI BANK",
     "ifsc": "YESB0KNB006"
    },
    {
     "name": "VALSAD DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "GSCB0VDC001"
    },
    {
     "name": "SBM BANK",
     "ifsc": "STCB0000065"
    },
    {
     "name": "DHARMAPURI CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010100"
    },
    {
     "name": "APNA SAHAKARI BANK",
     "ifsc": "ASBL0000001"
    },
    {
     "name": "BHARAT CO-OP BANK (MUMBAI)",
     "ifsc": "BCBM0000002"
    },
    {
     "name": "POORNAWADI NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CPNSBL"
    },
    {
     "name": "DCB BANK",
     "ifsc": "DCBL0000001"
    },
    {
     "name": "JAMMU AND KASHMIR BANK",
     "ifsc": "JAKA0AALLAH"
    },
    {
     "name": "LAKSHMI VILAS BANK",
     "ifsc": "LAVB0000999"
    },
    {
     "name": "ABHINANDAN URBAN CO-OP BANK",
     "ifsc": "HDFC0CMAN01"
    },
    {
     "name": "AHMEDNAGAR MERCHANTS CO-OP BANK",
     "ifsc": "HDFC0CMBANK"
    },
    {
     "name": "AKHAND ANAND CO-OP BANK",
     "ifsc": "HDFC0CAACOB"
    },
    {
     "name": "ANDHRA PRADESH GRAMEENA VIKAS BANK",
     "ifsc": "APGV0001101"
    },
    {
     "name": "ARUNACHAL PRADESH RURAL BANK",
     "ifsc": "SBIN0RRARGB"
    },
    {
     "name": "BHILWARA URBAN CO-OP BANK",
     "ifsc": "HDFC0CBHLUB"
    },
    {
     "name": "CHHATTISGARH RAJYA GRAMIN BANK",
     "ifsc": "CRGB0000001"
    },
    {
     "name": "DAPOLI URBAN CO-OP BANK",
     "ifsc": "IBKL0116DPC"
    },
    {
     "name": "ELLAQUAI DEHATI BANK",
     "ifsc": "SBIN0RRELGB"
    },
    {
     "name": "JANATA CO-OP BANK (MALEGAON)",
     "ifsc": "HDFC0CJBMLG"
    },
    {
     "name": "SUCO SOUHARDA SAHAKARI BANK",
     "ifsc": "HDFC0CSUCOB"
    },
    {
     "name": "KOKAN MERCANTILE CO-OP BANK",
     "ifsc": "KKBK0KMCB02"
    },
    {
     "name": "MADHYANCHAL GRAMIN BANK",
     "ifsc": "SBIN0RRMBGB"
    },
    {
     "name": "PUNE CANTONMENT SAHAKARI BANK",
     "ifsc": "HDFC0CPCSBL"
    },
    {
     "name": "MEGHALAYA RURAL BANK",
     "ifsc": "SBIN0RRMEGB"
    },
    {
     "name": "SVC CO-OP BANK",
     "ifsc": "SVCB0000001"
    },
    {
     "name": "RAJAPUR URBAN CO-OP BANK",
     "ifsc": "ICIC00RUCBL"
    },
    {
     "name": "RAJASTHAN MARUDHARA GRAMIN BANK",
     "ifsc": "RMGB0010001"
    },
    {
     "name": "THE SABARKANTHA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "GSCB0SKB001"
    },
    {
     "name": "SAURASHTRA GRAMIN BANK",
     "ifsc": "SGBA0000100"
    },
    {
     "name": "SHARAD SAHAKARI BANK",
     "ifsc": "HDFC0CSHSBL"
    },
    {
     "name": "THE BHAVNAGAR DISTRICT CO-OP BANK",
     "ifsc": "ICIC00BNDCB"
    },
    {
     "name": "SHRI ARIHANT CO-OP BANK",
     "ifsc": "ICIC00ARIHT"
    },
    {
     "name": "STERLING URBAN CO-OP BANK",
     "ifsc": "HDFC0CSTUCB"
    },
    {
     "name": "THE EENADU CO-OP URBAN BANK",
     "ifsc": "HDFC0CEENAD"
    },
    {
     "name": "THE GAYATRI CO-OPERATIVE URBAN BANK",
     "ifsc": "HDFC0CTGCUB"
    },
    {
     "name": "THE HASTI CO-OP BANK",
     "ifsc": "HCBL0000101"
    },
    {
     "name": "THE GANDEVI PEOPLES CO-OP BANK",
     "ifsc": "IBKL0068GP1"
    },
    {
     "name": "THE KANAKAMAHALAKSHMI CO-OP BANK",
     "ifsc": "IBKL0150KMC"
    },
    {
     "name": "THE AHMEDABAD DISTRICT CO-OP BANK",
     "ifsc": "GSCB0ADC001"
    },
    {
     "name": "SUVARNAYUG SAHAKARI BANK",
     "ifsc": "HDFC0CSUVRN"
    },
    {
     "name": "THE VALLABH VIDYANAGAR COMMERCIAL CO-OP BANK",
     "ifsc": "HDFC0CVVCCB"
    },
    {
     "name": "UTKAL GRAMEEN BANK",
     "ifsc": "SBIN0RRUKGB"
    },
    {
     "name": "UTTARAKHAND GRAMIN BANK",
     "ifsc": "SBIN0RRUTGB"
    },
    {
     "name": "VIKAS SOUHARDA CO-OP BANK",
     "ifsc": "ICIC00VSCBL"
    },
    {
     "name": "ABHYUDAYA CO-OP BANK",
     "ifsc": "ABHY0065001"
    },
    {
     "name": "AKOLA JANATA COMMERCIAL CO-OP BANK",
     "ifsc": "AKJB0000001"
    },
    {
     "name": "THE ANDHRA PRADESH STATE CO-OP BANK",
     "ifsc": "APBL0000001"
    },
    {
     "name": "ANDHRA PRAGATHI GRAMEENA BANK",
     "ifsc": "APGB0000001"
    },
    {
     "name": "BASSEIN CATHOLIC BANK",
     "ifsc": "BACB0000001"
    },
    {
     "name": "CITIBANK",
     "ifsc": "CITI0000001"
    },
    {
     "name": "CAPITAL SMALL FINANCE BANK",
     "ifsc": "CLBL0000001"
    },
    {
     "name": "SHRI CHHATRAPATI RAJARSHI SHAHU URBAN CO-OP BANK",
     "ifsc": "CRUB0000001"
    },
    {
     "name": "CSB Bank",
     "ifsc": "CSBK0000001"
    },
    {
     "name": "DBS BANK",
     "ifsc": "DBSS0IN0811"
    },
    {
     "name": "DHANLAXMI BANK",
     "ifsc": "DLXB0000001"
    },
    {
     "name": "DOMBIVLI NAGARI SAHAKARI BANK",
     "ifsc": "DNSB0000002"
    },
    {
     "name": "EQUITAS SMALL FINANCE BANK",
     "ifsc": "ESFB0000002"
    },
    {
     "name": "THE GREATER BOMBAY CO-OPERATIVE BANK",
     "ifsc": "GBCB0000001"
    },
    {
     "name": "THE HIMACHAL PRADESH STATE CO-OP BANK",
     "ifsc": "HPSC0000001"
    },
    {
     "name": "IDFC FIRST Bank",
     "ifsc": "IDFB0010201"
    },
    {
     "name": "JANASEVA SAHAKARI BANK (PUNE)",
     "ifsc": "JANA0000002"
    },
    {
     "name": "THE JALGAON PEOPLES CO-OP BANK",
     "ifsc": "JPCB0000001"
    },
    {
     "name": "THE KANGRA CENTRAL CO-OP BANK",
     "ifsc": "KACE0000002"
    },
    {
     "name": "THE KALUPUR COMMERCIAL CO-OP BANK",
     "ifsc": "KCCB0KLP001"
    },
    {
     "name": "THE KALYAN JANATA SAHAKARI BANK",
     "ifsc": "KJSB0000002"
    },
    {
     "name": "KERALA GRAMIN BANK",
     "ifsc": "KLGB0040101"
    },
    {
     "name": "KARUR VYSYA BANK",
     "ifsc": "KVBL0001254"
    },
    {
     "name": "KARNATAKA VIKAS GRAMEENA BANK",
     "ifsc": "KVGB0000001"
    },
    {
     "name": "MAHANAGAR CO-OP BANK",
     "ifsc": "MCBL0960002"
    },
    {
     "name": "THE MUNICIPAL CO-OP BANK",
     "ifsc": "MUBL0000001"
    },
    {
     "name": "THE NAINITAL BANK",
     "ifsc": "NTBL0DEL080"
    },
    {
     "name": "KARNATAKA GRAMIN BANK",
     "ifsc": "PKGB0010500"
    },
    {
     "name": "PRIME CO-OP BANK",
     "ifsc": "PMEC0000001"
    },
    {
     "name": "RAJKOT NAGARIK SAHAKARI BANK",
     "ifsc": "RNSB0000001"
    },
    {
     "name": "STANDARD CHARTERED BANK",
     "ifsc": "SCBL0036001"
    },
    {
     "name": "THE SURAT DISTRICT CO-OP BANK",
     "ifsc": "SDCB0000002"
    },
    {
     "name": "SHIVALIK MERCANTILE CO-OP BANK",
     "ifsc": "SMCB0001000"
    },
    {
     "name": "SARASWAT BANK",
     "ifsc": "SRCB0000001"
    },
    {
     "name": "THE SUTEX CO-OP BANK",
     "ifsc": "SUTB0000001"
    },
    {
     "name": "THE VARACHHA CO-OP BANK",
     "ifsc": "VARA0000001"
    },
    {
     "name": "SOUTH INDIAN BANK",
     "ifsc": "SIBL0000001"
    },
    {
     "name": "TAMILNAD MERCANTILE BANK",
     "ifsc": "TMBL0000001"
    },
    {
     "name": "BARODA RAJASTHAN KSHETRIYA GRAMIN BANK",
     "ifsc": "BARB0BRGBXX"
    },
    {
     "name": "ASSAM GRAMIN VIKASH BANK",
     "ifsc": "PUNB0RRBAGB"
    },
    {
     "name": "BARODA GUJARAT GRAMIN BANK",
     "ifsc": "BARB0BGGBXX"
    },
    {
     "name": "CHAITANYA GODAVARI GRAMEENA BANK",
     "ifsc": "UBIN0CG7999"
    },
    {
     "name": "HIMACHAL PRADESH GRAMIN BANK",
     "ifsc": "PUNB0HPGB04"
    },
    {
     "name": "ODISHA GRAMYA BANK",
     "ifsc": "IOBA0ROGB01"
    },
    {
     "name": "TAMIL NADU GRAMA BANK",
     "ifsc": "IDIB0PLB001"
    },
    {
     "name": "PUNJAB GRAMIN BANK",
     "ifsc": "PUNB0PGB003"
    },
    {
     "name": "SAPTAGIRI GRAMEENA BANK",
     "ifsc": "IDIB0SGB001"
    },
    {
     "name": "SARVA HARYANA GRAMIN BANK",
     "ifsc": "PUNB0HGB001"
    },
    {
     "name": "TRIPURA GRAMIN BANK",
     "ifsc": "PUNB0RRBTGB"
    },
    {
     "name": "PASCHIM BANGA GRAMIN BANK",
     "ifsc": "UCBA0RRBPBG"
    },
    {
     "name": "UJJIVAN SMALL FINANCE BANK",
     "ifsc": "UJVN0099999"
    },
    {
     "name": "ESAF SMALL FINANCE BANK",
     "ifsc": "ESMF0000001"
    },
    {
     "name": "SURYODAY SMALL FINANCE BANK",
     "ifsc": "SURY0HE0001"
    },
    {
     "name": "AU SMALL FINANCE BANK",
     "ifsc": "AUBL0002011"
    },
    {
     "name": "UTKARSH SMALL FINANCE BANK",
     "ifsc": "UTKS0000002"
    },
    {
     "name": "UTTAR BANGA KSHETRIYA GRAMIN BANK",
     "ifsc": "CBIN0R40012"
    },
    {
     "name": "VIDHARBHA KONKAN GRAMIN BANK",
     "ifsc": "BKID0WAINGB"
    },
    {
     "name": "PUNE DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "HDFC0CPDCCB"
    },
    {
     "name": "ASSAM CO-OP APEX BANK",
     "ifsc": "HDFC0CACABL"
    },
    {
     "name": "THE DELHI STATE CO-OP BANK",
     "ifsc": "DLSC0000001"
    },
    {
     "name": "THE JAMMU AND KASHMIR STATE CO-OP BANK",
     "ifsc": "UTIB0SJKCB1"
    },
    {
     "name": "THE PUNJAB STATE CO-OP BANK",
     "ifsc": "UTIB0PSCB01"
    },
    {
     "name": "TRIPURA STATE CO-OP BANK",
     "ifsc": "ICIC00TSCBL"
    },
    {
     "name": "THE WEST BENGAL STATE CO-OP BANK",
     "ifsc": "WBSC0000001"
    },
    {
     "name": "RAJKOT DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "GSCB0RJT001"
    },
    {
     "name": "FARUKKHABAD DISTRICT CO-OP BANK",
     "ifsc": "ICIC00FDCBL"
    },
    {
     "name": "ALMORA URBAN CO-OP BANK",
     "ifsc": "AUCB0000001"
    },
    {
     "name": "BANK OF AMERICA",
     "ifsc": "BOFA0MM6205"
    },
    {
     "name": "THE PANIPAT URBAN CO-OP BANK",
     "ifsc": "YESB0PUCB01"
    },
    {
     "name": "WOORI BANK",
     "ifsc": "HVBK0000001"
    },
    {
     "name": "TJSB SAHAKARI BANK",
     "ifsc": "TJSB0000001"
    },
    {
     "name": "THE THANE DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TDCB0000001"
    },
    {
     "name": "BANK OF CEYLON",
     "ifsc": "BCEY0000001"
    },
    {
     "name": "JIO PAYMENTS BANK",
     "ifsc": "JIOP0000001"
    },
    {
     "name": "DISTRICT CO-OP BANK (LAKHIMPUR KHERI)",
     "ifsc": "ICIC00KHIRI"
    },
    {
     "name": "SIWAN CENTRAL CO-OP BANK",
     "ifsc": "IBKL01076SB"
    },
    {
     "name": "THE HINDUSTAN CO-OP BANK",
     "ifsc": "SVCB0001002"
    },
    {
     "name": "JANA SMALL FINANCE BANK",
     "ifsc": "JSFB0CPC002"
    },
    {
     "name": "PALI URBAN CO-OP BANK",
     "ifsc": "HDFC0CPUB03"
    },
    {
     "name": "THE KANGRA CO-OP BANK",
     "ifsc": "KANG0000001"
    },
    {
     "name": "THE ROHIKA CENTRAL CO-OP BANK",
     "ifsc": "IBKL01066RC"
    },
    {
     "name": "BARODA CENTRAL CO-OP BANK",
     "ifsc": "GSCB0BRD001"
    },
    {
     "name": "BHOPAL CO-OP CENTRAL BANK",
     "ifsc": "CBIN0MPDCAE"
    },
    {
     "name": "CITIZENS CO-OP BANK",
     "ifsc": "IBKL01642C1"
    },
    {
     "name": "DARUSSALAM CO-OP URBAN BANK",
     "ifsc": "HDFC0CDUCBL"
    },
    {
     "name": "DEENDAYAL NAGARI SAHAKARI BANK",
     "ifsc": "ICIC00DDNSB"
    },
    {
     "name": "FINGROWTH CO-OP BANK",
     "ifsc": "HDFC0CTUCBL"
    },
    {
     "name": "HIMATNAGAR NAGARIK SAHAKARI BANK",
     "ifsc": "IBKL0218HNS"
    },
    {
     "name": "THE KRANTHI CO-OP URBAN BANK",
     "ifsc": "UTIB0SKRN01"
    },
    {
     "name": "KURLA NAGRIK CO-OP BANK",
     "ifsc": "YESB0KURLA1"
    },
    {
     "name": "MANORAMA CO-OP BANK",
     "ifsc": "HDFC0CMANCB"
    },
    {
     "name": "NAVSARJAN INDUSTRIAL CO-OP BANK",
     "ifsc": "HDFC0CNICBL"
    },
    {
     "name": "THE RAIGAD DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL0299RDC"
    },
    {
     "name": "SAIBABA NAGARI SAHAKARI BANK",
     "ifsc": "UTIB0SSNS01"
    },
    {
     "name": "SAMATA SAHAKARI BANK",
     "ifsc": "SRCB0SAM001"
    },
    {
     "name": "SOLAPUR SIDDHESHWAR SAH BANK",
     "ifsc": "HDFC0CSIDDH"
    },
    {
     "name": "BANASKANTHA MERCANTILE CO-OP BANK",
     "ifsc": "TBMC0001001"
    },
    {
     "name": "THE BURDWAN CENTRAL CO-OP BANK",
     "ifsc": "HDFC0CBCCBL"
    },
    {
     "name": "GANDHINAGAR NAG CO-OP BANK",
     "ifsc": "HDFC0CGNCBL"
    },
    {
     "name": "KANARA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "KSCB0016001"
    },
    {
     "name": "THE MANMANDIR CO-OP BANK",
     "ifsc": "ICIC0006405"
    },
    {
     "name": "MEHSANA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "GSCB0MSN001"
    },
    {
     "name": "THE NARODA NAGRIK CO-OP BANK",
     "ifsc": "GSCB0UNNCBL"
    },
    {
     "name": "THE NAWANAGAR CO-OP BANK",
     "ifsc": "IBKL0427NCB"
    },
    {
     "name": "PATLIPUTRA CENTRAL CO-OP BANK",
     "ifsc": "IBKL0140PCC"
    },
    {
     "name": "THE SANGAMNER MERCHANTS CO-OP BANK",
     "ifsc": "HDFC0CTSMCB"
    },
    {
     "name": "THE SSK CO-OP BANK",
     "ifsc": "UTIB0SSSKCB"
    },
    {
     "name": "THE UDUPI CO-OP TOWN BANK",
     "ifsc": "UTIB0SUCTBL"
    },
    {
     "name": "UDHAM SINGH NAGAR DISTRICT CO-OP BANK",
     "ifsc": "ICIC00USNDC"
    },
    {
     "name": "URBAN CO-OP BANK (BAREILLY)",
     "ifsc": "IBKL0232UCB"
    },
    {
     "name": "SRI VASAVAMBA CO-OP BANK",
     "ifsc": "HDFC0CSVCBA"
    },
    {
     "name": "THE VISAKHAPATNAM CO-OP BANK",
     "ifsc": "IBKL0031VCB"
    },
    {
     "name": "MADHYA BHARAT GRAMIN BANK",
     "ifsc": "SBIN0RRMBGB"
    },
    {
     "name": "ADARSH CO-OP URBAN BANK (HYDERABAD)",
     "ifsc": "ICIC00ADRSH"
    },
    {
     "name": "JAMMU AND KASHMIR GRAMEEN BANK",
     "ifsc": "JAKA0GRAMEN"
    },
    {
     "name": "JILA SAHKARI BANK (PITHORAGARH)",
     "ifsc": "IBKL0768PJS"
    },
    {
     "name": "THE GADCHIROLI DISTRICT CENTRAL CO-O BANK (GDCC BANK)",
     "ifsc": "GDCB0000001"
    },
    {
     "name": "THE DAHOD URBAN CO-OP BANK",
     "ifsc": "HDFC0CDUCBE"
    },
    {
     "name": "KOTTAKKAL CO-OP URBAN BANK",
     "ifsc": "UTIB0SKCU78"
    },
    {
     "name": "THE MODASA NAGARIK SAHAKARI BANK",
     "ifsc": "KKBK0MNSB01"
    },
    {
     "name": "SURAT NATIONAL CO-OP BANK",
     "ifsc": "SUNB0000002"
    },
    {
     "name": "THE NANDURA URBAN CO-OP BANK",
     "ifsc": "HDFC0CNUCBN"
    },
    {
     "name": "PANCHMAHAL DISTRICT CO-OP BANK",
     "ifsc": "GSCB0PDC001"
    },
    {
     "name": "URBAN CO-OP BANK (SIDDHARTHANAGAR)",
     "ifsc": "ICIC00SIDRH"
    },
    {
     "name": "THE NATIONAL CENTRAL CO-OP BANK",
     "ifsc": "IBKL01248NC"
    },
    {
     "name": "SHREE MAHAVIR SAHAKARI BANK",
     "ifsc": "KKBK0SMSB01"
    },
    {
     "name": "VAISHYA NAGARI SAHAKARI BANK",
     "ifsc": "UTIB0SVNS01"
    },
    {
     "name": "ZILA SAHAKARI BANK (LUCKNOW)",
     "ifsc": "ICIC00ZSBLL"
    },
    {
     "name": "ZILA SAHAKARI BANK (CHAMOLI)",
     "ifsc": "IBKL070CZSB"
    },
    {
     "name": "MAHILA NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CMNSBM"
    },
    {
     "name": "AMRELI JILLA SAHAKARI BANK",
     "ifsc": "GSCB0AMR001"
    },
    {
     "name": "NAVI MUMBAI CO-OP BANK",
     "ifsc": "IBKL0123NMC"
    },
    {
     "name": "NIDHI CO-OP BANK",
     "ifsc": "ICIC00NIDHI"
    },
    {
     "name": "THE KUKARWADA NAGRIK SAH BANK",
     "ifsc": "HDFC0CTKNSB"
    },
    {
     "name": "MODEL CO-OP BANK",
     "ifsc": "MDBK0000001"
    },
    {
     "name": "ZILA SAHAKARI BANK (KOTDWARA)",
     "ifsc": "ICIC00ZSKTW"
    },
    {
     "name": "THE MEHSANA URBAN CO-OP BANK",
     "ifsc": "MSNU0000029"
    },
    {
     "name": "PRATHAMA UP GRAMIN BANK",
     "ifsc": "PUNB0SUPGB5"
    },
    {
     "name": "ZILA SAHAKARI BANK (RAMPUR)",
     "ifsc": "ICIC00RAMPR"
    },
    {
     "name": "MURSHIDABAD DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "WBSC0MCCB15"
    },
    {
     "name": "THE DHANERA MERCANTILE CO-OP BANK",
     "ifsc": "HDFC0CDMCBL"
    },
    {
     "name": "NEW INDIA CO-OP BANK",
     "ifsc": "NICB0000001"
    },
    {
     "name": "THE GOPALGANJ CENTRAL CO-OP BANK",
     "ifsc": "IBKL01011GC"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (KHARGONE)",
     "ifsc": "CBIN0MPDCAS"
    },
    {
     "name": "THE CUDDALORE DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011200"
    },
    {
     "name": "THE VELLORE DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011600"
    },
    {
     "name": "THE PUSAD URBAN CO-OP BANK",
     "ifsc": "YESB0PUB001"
    },
    {
     "name": "THE TIRUVANNAMALAI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0012000"
    },
    {
     "name": "THE CHENNAI CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010500"
    },
    {
     "name": "THE DINDIGUL CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011700"
    },
    {
     "name": "THE PUDUKKOTTAI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010900"
    },
    {
     "name": "THE TIRUCHIRAPALLI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011400"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (JAGDALPUR)",
     "ifsc": "UTIB0SJSJ01"
    },
    {
     "name": "BOMBAY MERCANTILE CO-OP BANK",
     "ifsc": "BMCB0000002"
    },
    {
     "name": "THE MEHSANA NAGRIK SAHAKARI BANK",
     "ifsc": "IBKL0443MNB"
    },
    {
     "name": "RATNAGIRI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL0574RDC"
    },
    {
     "name": "SANT SOPANKAKA SAHAKARI BANK",
     "ifsc": "SANT0000002"
    },
    {
     "name": "THE SANGLI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL0487SDC"
    },
    {
     "name": "AMBARNATH JAI HIND CO-OP BANK",
     "ifsc": "AJHC0001002"
    },
    {
     "name": "BALASORE BHADRAK CENTRAL CO-OP BANK",
     "ifsc": "YESB0BBCB00"
    },
    {
     "name": "CAUVERI KALPATARU GRAMEENA BANK",
     "ifsc": "SBIN0RRCKGB"
    },
    {
     "name": "CHEMBUR NAGARIK SAHAKARI BANK",
     "ifsc": "SRCB0CNS001"
    },
    {
     "name": "CUTTACK CENTRAL CO-OP BANK",
     "ifsc": "IBKL0217C01"
    },
    {
     "name": "DR ANNASAHEB CHOUGULE URBAN CO-OP BANK",
     "ifsc": "HDFC0CDACUB"
    },
    {
     "name": "GODAVARI URBAN CO-OP BANK (VAZIRABAD)",
     "ifsc": "YESB0GUCB01"
    },
    {
     "name": "HUTATMA SAHAKARI BANK",
     "ifsc": "ICIC00HSBLW"
    },
    {
     "name": "INTEGRAL URBAN CO-OP BANK",
     "ifsc": "HDFC0CIUCBL"
    },
    {
     "name": "IRINJALAKUDA TOWN CO-OP BANK (ITU BANK)",
     "ifsc": "ITBL0000001"
    },
    {
     "name": "THE BHAWANIPATNA CENTRAL CO-OP BANK",
     "ifsc": "ICIC00BHCCB"
    },
    {
     "name": "JALORE NAGRIK SAHKARI BANK",
     "ifsc": "HDFC0CJALOR"
    },
    {
     "name": "JANATA SAHAKARI BANK (PUNE)",
     "ifsc": "JSBP0000098"
    },
    {
     "name": "JHARKHAND GRAMIN BANK",
     "ifsc": "BKID0JHARGB"
    },
    {
     "name": "KARNATAKA CENTRAL CO-OP BANK",
     "ifsc": "KSCB0015001"
    },
    {
     "name": "KEONJHAR CENTRAL CO-OP BANK",
     "ifsc": "UTIB0SKCCBL"
    },
    {
     "name": "THE KOLHAPUR URBAN CO-OP BANK",
     "ifsc": "HDFC0CKUCBL"
    },
    {
     "name": "KOTTAYAM CO-OP URBAN BANK",
     "ifsc": "IBKL0027K01"
    },
    {
     "name": "LANGPI DEHANGI RURAL BANK",
     "ifsc": "SBIN0RRLDGB"
    },
    {
     "name": "LOKMANGAL CO-OP BANK",
     "ifsc": "IBKL0478LOK"
    },
    {
     "name": "M S CO-OP BANK (MSC BANK)",
     "ifsc": "IBKL0553MSC"
    },
    {
     "name": "MANVI PATTANA SOUHARDA SAHKARI BANK",
     "ifsc": "HDFC0CMPSSB"
    },
    {
     "name": "MARATHA CO-OP BANK",
     "ifsc": "IBKL0101MCB"
    },
    {
     "name": "NAGALAND RURAL BANK",
     "ifsc": "SBIN0RRNLGB"
    },
    {
     "name": "THE MALAD SAHAKARI BANK",
     "ifsc": "TMSB0000002"
    },
    {
     "name": "PARSHWANATH CO-OP BANK"
    },
    {
     "name": "PAVANA SAHAKARI BANK",
     "ifsc": "PSBL0000001"
    },
    {
     "name": "PUNE MERCHANTS CO-OP BANK",
     "ifsc": "IBKL0548PMC"
    },
    {
     "name": "RAIPUR URBAN MERCHANTILE CO-OP BANK",
     "ifsc": "HDFC0CTRUMC"
    },
    {
     "name": "RAJARAMBAPU SAHAKARI BANK",
     "ifsc": "RRBP0000001"
    },
    {
     "name": "SADHANA SAHAKARI BANK (PUNE)",
     "ifsc": "HDFC0CSBL02"
    },
    {
     "name": "SARDAR BHILADWALA PARDI PEOPLES CO-OP BANK"
    },
    {
     "name": "SHIVAJIRAO BHOSALE SAHAKARI BANK",
     "ifsc": "HDFC0CSBB01"
    },
    {
     "name": "SHRI MAHALAXMI CO-OP BANK",
     "ifsc": "IBKL0116MCO"
    },
    {
     "name": "SHRI VEERSHAIV CO-OP BANK",
     "ifsc": "SVSH0000001"
    },
    {
     "name": "SINDHUDURG DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "SIDC0001046"
    },
    {
     "name": "SHREE SHARADA SAHAKARI BANK (PUNE)",
     "ifsc": "YESB0SHBK01"
    },
    {
     "name": "THE BARAMATI SAHAKARI BANK",
     "ifsc": "BARA0000001"
    },
    {
     "name": "SUDHA CO-OP URBAN BANK",
     "ifsc": "HDFC0CSUCUB"
    },
    {
     "name": "SUMERPUR MERCHANTILE URBAN CO-OP BANK",
     "ifsc": "HDFC0CS1812"
    },
    {
     "name": "BASAVA BANK",
     "ifsc": "ICIC00SBSBN"
    },
    {
     "name": "THE AJARA URBAN CO-OP BANK",
     "ifsc": "IBKL0116AUC"
    },
    {
     "name": "THE ASKA CO-OP CENTRAL BANK",
     "ifsc": "UTIB0SASKAC"
    },
    {
     "name": "THE BANTRA CO-OPERTIVE BANK",
     "ifsc": "HDFC0CBCBBK"
    },
    {
     "name": "THE BUSINESS CO-OP BANK",
     "ifsc": "YESB0BCBL02"
    },
    {
     "name": "THE KORAPUT CENTRAL CO-OP BANK",
     "ifsc": "UTIB0SKOCBL"
    },
    {
     "name": "THE MAYANI URBAN CO-OP BANK",
     "ifsc": "ICIC00TMUCB"
    },
    {
     "name": "THE PANDHARPUR MERCHANTS CO-OP BANK",
     "ifsc": "PUCB0000001"
    },
    {
     "name": "THE PATDI NAGRIK SAHAKARI BANK",
     "ifsc": "GSCB0UTPNBL"
    },
    {
     "name": "THE SAURASHTRA CO-OP BANK",
     "ifsc": "GSCB0USAURA"
    },
    {
     "name": "THE SHIRPUR PEOPLES CO-OP BANK",
     "ifsc": "KKBK0SPCB01"
    },
    {
     "name": "UDAIPUR MAHILA URBAN CO-OP BANK",
     "ifsc": "ICIC00UMUCB"
    },
    {
     "name": "BELAGAVI SHREE BASAVESHWAR CO-OP BANK",
     "ifsc": "UTIB0S63SBC"
    },
    {
     "name": "THE AKOLA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "ADCC0000001"
    },
    {
     "name": "THE AHMEDABAD MERCANTILE CO-OP BANK",
     "ifsc": "AMCB0660001"
    },
    {
     "name": "THE AP MAHESH CO-OP URBAN BANK",
     "ifsc": "APMC0000002"
    },
    {
     "name": "BARCLAYS BANK",
     "ifsc": "BARC0INBB01"
    },
    {
     "name": "BNP PARIBAS",
     "ifsc": "BNPA0009008"
    },
    {
     "name": "CITIZEN CREDIT CO-OP BANK",
     "ifsc": "CCBL0209002"
    },
    {
     "name": "PUNE PEOPLES CO-OP BANK",
     "ifsc": "IBKL0548PPC"
    },
    {
     "name": "JANASEVA SAHAKARI BANK (BORIVLI)",
     "ifsc": "JASB0000001"
    },
    {
     "name": "JANAKALYAN SAHAKARI BANK",
     "ifsc": "JSBL0000002"
    },
    {
     "name": "KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BANK",
     "ifsc": "KAIJ0000001"
    },
    {
     "name": "THE KARAD URBAN CO-OP BANK",
     "ifsc": "KUCB0488000"
    },
    {
     "name": "NUTAN NAGARIK SAHAKARI BANK",
     "ifsc": "NNSB0128002"
    },
    {
     "name": "GP PARSIK SAHAKARI BANK",
     "ifsc": "PJSB0000001"
    },
    {
     "name": "PUNJAB AND MAHARASHTRA CO-OP BANK",
     "ifsc": "PMCB0000001"
    },
    {
     "name": "THE PANDHARPUR URBAN CO-OP BANK",
     "ifsc": "ICIC00PUCCB"
    },
    {
     "name": "RABOBANK INTERNATIONAL",
     "ifsc": "RABO0000001"
    },
    {
     "name": "RAJGURUNAGAR SAHAKARI BANK",
     "ifsc": "RSBL0000001"
    },
    {
     "name": "THANE BHARAT SAHAKARI BANK",
     "ifsc": "TBSB0000001"
    },
    {
     "name": "TAMILNADU STATE APEX CO-OP BANK (TNSC BANK)",
     "ifsc": "TNSC0000001"
    },
    {
     "name": "TELANGANA STATE CO-OP APEX BANK",
     "ifsc": "TSAB0000001"
    },
    {
     "name": "THE VISHWESHWAR SAHAKARI BANK",
     "ifsc": "VSBL0000001"
    },
    {
     "name": "VASAI VIKAS SAHAKARI BANK",
     "ifsc": "VVSB0000001"
    },
    {
     "name": "BERHAMPORE CENTRAL CO-OP BANK",
     "ifsc": "IBKL0216BCB"
    },
    {
     "name": "ANGUL UNITED CENTRAL CO-OP BANK",
     "ifsc": "YESB0ACCB01"
    },
    {
     "name": "BOUDH CENTRAL CO-OP BANK",
     "ifsc": "YESB0BCCB00"
    },
    {
     "name": "BOLANGIR DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "YESB0BDCB00"
    },
    {
     "name": "THE BANKI CENTRAL CO-OP BANK",
     "ifsc": "YESB0BNKCCB"
    },
    {
     "name": "CHIKHLI URBAN CO-OP BANK",
     "ifsc": "HDFC0CCUB01"
    },
    {
     "name": "KAIRA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "YESB0KDCC01"
    },
    {
     "name": "KHURDA CENTRAL CO-OP BANK",
     "ifsc": "YESB0KHCB01"
    },
    {
     "name": "MAYURBHANJ CENTRAL CO-OP BANK",
     "ifsc": "YESB0MCCBHO"
    },
    {
     "name": "THE NATIONAL CO-OPERATIVE BANK",
     "ifsc": "YESB0NBL002"
    },
    {
     "name": "NAYAGARH DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "YESB0NDB001"
    },
    {
     "name": "THE POCHAMPALLY CO-OPERATIVE URBAN BANK",
     "ifsc": "HDFC0CPCUBL"
    },
    {
     "name": "THE SAMBALPUR DISTRICT CO-OP CENTRAL BANK",
     "ifsc": "YESB0SBPBHO"
    },
    {
     "name": "SUNDARGARH CENTRAL CO-OP BANK",
     "ifsc": "YESB0SNGB13"
    },
    {
     "name": "UNITED PURI NIMAPARA CENTRAL CO-OP BANK",
     "ifsc": "YESB0UPNC01"
    },
    {
     "name": "THE UDAIPUR URBAN CO-OP BANK",
     "ifsc": "YESB0UUCB07"
    },
    {
     "name": "THE YADAGIRI LAKSHMI NARASIMHA SWAMY CO-OP URBAN BANK"
    },
    {
     "name": "NKGSB CO-OP BANK",
     "ifsc": "NKGS0000001"
    },
    {
     "name": "PANDYAN GRAMA BANK",
     "ifsc": "IOBA0PGB001"
    },
    {
     "name": "THRISSUR DISTRICT CO-OP BANK",
     "ifsc": "IBKL0269TDC"
    },
    {
     "name": "BIHAR STATE CO-OP BANK",
     "ifsc": "YESB0BSCB01"
    },
    {
     "name": "LATUR URBAN CO-OP BANK",
     "ifsc": "IBKL0497LUC"
    },
    {
     "name": "THE ODISHA STATE CO-OP BANK",
     "ifsc": "ORCB0000001"
    },
    {
     "name": "SAMRUDDHI CO-OP BANK",
     "ifsc": "IBKL0041SCB"
    },
    {
     "name": "PUDUVAI BHARATHIAR GRAMA BANK",
     "ifsc": "IDIB0PBG001"
    },
    {
     "name": "ANDAMAN & NICOBAR STATE CO-OP BANK",
     "ifsc": "HDFC0CANSCB"
    },
    {
     "name": "ARUNACHAL PRADESH STATE CO-OP APEX BANK",
     "ifsc": "YESB0ARCB01"
    },
    {
     "name": "CHANDIGARH STATE CO-OP BANK",
     "ifsc": "UTIB0CSCB22"
    },
    {
     "name": "CHHATTISGARH STATE CO-OP BANK",
     "ifsc": "CBINOCGDCBN"
    },
    {
     "name": "GOA STATE CO-OP BANK",
     "ifsc": "YESB0GSCB32"
    },
    {
     "name": "HARYANA STATE CO-OP APEX BANK",
     "ifsc": "HARC0000001"
    },
    {
     "name": "JHARKHAND STATE CO-OP BANK",
     "ifsc": "IBKL0063JCB"
    },
    {
     "name": "THE KARNATAKA STATE CO-OP APEX BANK",
     "ifsc": "KSCB0000001"
    },
    {
     "name": "KERALA STATE CO-OP BANK",
     "ifsc": "KSBK0000002"
    },
    {
     "name": "MADHYA PRADESH RAJYA SAHAKARI BANK",
     "ifsc": "CBIN0MPABAA"
    },
    {
     "name": "MANIPUR STATE CO-OP BANK",
     "ifsc": "YESB0MSCB01"
    },
    {
     "name": "MEGHALAYA CO-OP APEX BANK",
     "ifsc": "MCAB0000001"
    },
    {
     "name": "MIZORAM CO-OP APEX BANK",
     "ifsc": "YESB0MAB001"
    },
    {
     "name": "NAGALAND STATE CO-OP BANK",
     "ifsc": "UTIB0SNSCB1"
    },
    {
     "name": "PONDICHERRY CO-OP URBAN BANK",
     "ifsc": "TNSC0160101"
    },
    {
     "name": "THE RAJASTHAN STATE CO-OP BANK",
     "ifsc": "RSCB0000001"
    },
    {
     "name": "THE SIKKIM STATE CO-OP BANK",
     "ifsc": "YESB0SSCB01"
    },
    {
     "name": "UTTAR PRADESH CO-OP BANK",
     "ifsc": "UPCB0000001"
    },
    {
     "name": "UTTARAKHAND STATE CO-OP BANK",
     "ifsc": "ICIC00USCBD"
    },
    {
     "name": "RAJDHANI NAGAR SAHKARI BANK",
     "ifsc": "YESB0RNSB01"
    },
    {
     "name": "LIC OF INDIA STAFF CO-OP BANK",
     "ifsc": "IBKL0745LIC"
    },
    {
     "name": "ABU DHABI COMMERCIAL BANK",
     "ifsc": "ADCB0000001"
    },
    {
     "name": "AUSTRALIA AND NEW ZEALAND BANKING GROUP",
     "ifsc": "ANZB0000001"
    },
    {
     "name": "RAJASTHAN GRAMIN BANK",
     "ifsc": "PUNB0RGB002"
    },
    {
     "name": "WESTPAC BANKING CORPORATION",
     "ifsc": "WPAC0000001"
    },
    {
     "name": "TUMKUR GRAIN MERCHANTS CP-OP BANK",
     "ifsc": "TGMB0000001"
    },
    {
     "name": "THE ZOROASTRIAN CO-OP BANK",
     "ifsc": "ZCBL0000002"
    },
    {
     "name": "KOZHIKODE DISTRICT CO-OP BANK (KDC BANK)",
     "ifsc": "KDCB0000001"
    },
    {
     "name": "BANK OF BAHRAIN AND KUWAIT",
     "ifsc": "BBKM0000001"
    },
    {
     "name": "BANK OF TOKYO MITSUBISHI",
     "ifsc": "BOTM0003611"
    },
    {
     "name": "NORTH EAST SMALL FINANCE BANK",
     "ifsc": "NESF0000001"
    },
    {
     "name": "DEOGIRI NAGARI SAHAKARI BANK"
    },
    {
     "name": "NAGPUR NAGRIK SAHAKARI BANK",
     "ifsc": "NGSB0000001"
    },
    {
     "name": "SAMARTH SAH BANK - JALNA",
     "ifsc": "HDFC0CSSBMJ"
    },
    {
     "name": "SHIKSHAK SAHAKARI BANK",
     "ifsc": "SKSB0000001"
    },
    {
     "name": "JALGAON JANATA SAHKARI BANK",
     "ifsc": "JJSB0000001"
    },
    {
     "name": "SOLAPUR JANATA SAHKARI BANK",
     "ifsc": "SJSB0000001"
    },
    {
     "name": "THE KURMANCHAL NAGAR SAHKARI BANK",
     "ifsc": "KNSB0000001"
    },
    {
     "name": "THE NAGAR SAHAKARI BANK (GORAKHPUR)",
     "ifsc": "UTIB0NBGKP1"
    },
    {
     "name": "THE FARIDABAD CENTRAL CO-OP BANK",
     "ifsc": "UTIB0SFCB01"
    },
    {
     "name": "BHATPARA NAIHATI CO-OP BANK",
     "ifsc": "WBSC0BUCB01"
    },
    {
     "name": "SATARA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "SDCE0000001"
    },
    {
     "name": "THE CENTRAL CO-OP BANK",
     "ifsc": "RSCB0034099"
    },
    {
     "name": "RAJARSHI SHAHU SAHAKARI BANK",
     "ifsc": "HDFC0CRSSBL"
    },
    {
     "name": "ADARNIYA P D PATILSAHEB SAHAKARI BANK",
     "ifsc": "HDFC0CPDPBK"
    },
    {
     "name": "ADARSH MAHILA NAGARI SAHAKARI BANK",
     "ifsc": "YESB0AMSB01"
    },
    {
     "name": "AJANTHA URBAN CO-OP BANK",
     "ifsc": "YESB0AUCB01"
    },
    {
     "name": "ALAPUZHA DISTRICT CO-OP BANK",
     "ifsc": "UTIB0SADC83"
    },
    {
     "name": "AMAN SAHAKARI BANK",
     "ifsc": "ICIC00AMSBL"
    },
    {
     "name": "AMBAJOGAI PEOPLES CO-OP BANK",
     "ifsc": "HDFC0CAPCBL"
    },
    {
     "name": "ASSOCIATE CO-OP BANK",
     "ifsc": "YESB0ASCB02"
    },
    {
     "name": "BALOTRA URBAN CO-OP BANK",
     "ifsc": "ICIC00BALUC"
    },
    {
     "name": "BAPUJI CO-OP BANK",
     "ifsc": "IBKL0364BCB"
    },
    {
     "name": "BHADRADRI CO-OP URBAN BANK",
     "ifsc": "SRCB0BCB808"
    },
    {
     "name": "CG RAJYA SAHAKRI BANK",
     "ifsc": "CBIN0CGDCBN"
    },
    {
     "name": "CENTRAL CO-OP BANK",
     "ifsc": "IBKL0722CCB"
    },
    {
     "name": "CHARTERED SAHAKARI BANK",
     "ifsc": "YESB0CSB001"
    },
    {
     "name": "CHITTORGARH URBAN CO-OP BANK",
     "ifsc": "HDFC0CCUCBL"
    },
    {
     "name": "CITIZEN CO-OP BANK (NOIDA)",
     "ifsc": "HDFC0CCBL06"
    },
    {
     "name": "COASTAL LOCAL AREA BANK",
     "ifsc": "MAHB000CB01"
    },
    {
     "name": "JAYSINGPUR UDGAON SAHAKARI BANK",
     "ifsc": "ICIC00JUSBL"
    },
    {
     "name": "EMIRATES NBD BANK",
     "ifsc": "EBIL0000001"
    },
    {
     "name": "JANATA SAHAKARI BANK (AJARA)",
     "ifsc": "IBKL0116JSB"
    },
    {
     "name": "JAWAHAR CO-OP BANK",
     "ifsc": "IBKL0116JCB"
    },
    {
     "name": "JIJAMATA MAHILA SAHAKARI BANK",
     "ifsc": "HDFC0CJMS01"
    },
    {
     "name": "JIVAN COMMERCIAL CO-OP BANK",
     "ifsc": "IBKL0JIVAN1"
    },
    {
     "name": "JODHPUR NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CJNB08"
    },
    {
     "name": "THE JUNAGADH COMMERCIAL CO-OP BANK",
     "ifsc": "HDFC0CJCCBL"
    },
    {
     "name": "THE KAKATIYA CO-OP URBAN BANK",
     "ifsc": "UTIB0SKCUB1"
    },
    {
     "name": "KANKARIA MANINAGAR NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CKMNSB"
    },
    {
     "name": "KASHMIR MERCANTILE CO-OP BANK",
     "ifsc": "HDFC0CKAMCO"
    },
    {
     "name": "THE KHAGARIA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL01077KD"
    },
    {
     "name": "KHATTRI CO-OP URBAN BANK",
     "ifsc": "YESB0KCUB01"
    },
    {
     "name": "KHEDA PEOPLES CO-OP BANK",
     "ifsc": "GSCB0UKPCBL"
    },
    {
     "name": "KOLHAPUR MAHILA SAHAKARI BANK",
     "ifsc": "HDFC0CKMB01"
    },
    {
     "name": "KOTA NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CKNB02"
    },
    {
     "name": "LAKHIMPUR URBAN CO-OP BANK",
     "ifsc": "ICIC00LKUCB"
    },
    {
     "name": "MAHAVEER CO-OP URBAN BANK",
     "ifsc": "HDFC0CMCUBL"
    },
    {
     "name": "MAHESH SAHAKARI BANK (PUNE)",
     "ifsc": "MSBL0000001"
    },
    {
     "name": "MALVIYA URBAN CO-OP BANK",
     "ifsc": "HDFC0CMUCBL"
    },
    {
     "name": "THE MANJERI CO-OP URBAN BANK",
     "ifsc": "ICIC00MCUBL"
    },
    {
     "name": "MANSING CO-OP BANK",
     "ifsc": "HDFC0CMCBLD"
    },
    {
     "name": "MUDGAL URBAN CO-OP BANK",
     "ifsc": "UTIB0SMUB01"
    },
    {
     "name": "NAINITAL DISTRICT CO-OP BANK",
     "ifsc": "YESB0NDCB01"
    },
    {
     "name": "THE NILAMBUR CO-OP URBAN BANK",
     "ifsc": "NCUB0000001"
    },
    {
     "name": "NIRMAL URBAN CO-OP BANK",
     "ifsc": "HDFC0CNB311"
    },
    {
     "name": "PATAN NAGARIK SAHAKARI BANK",
     "ifsc": "GSCB0UPATAN"
    },
    {
     "name": "THE PEOPLES URBAN CO-OP BANK",
     "ifsc": "IBKL0341PUB"
    },
    {
     "name": "PIMPRI CHINCHWAD SAHAKARI BANK",
     "ifsc": "IBKL0087PCS"
    },
    {
     "name": "PRAGATI SAHAKARI BANK"
    },
    {
     "name": "SAMPADA SAHAKARI BANK",
     "ifsc": "IBKL0459SBS"
    },
    {
     "name": "SANDUR PATTANA SOUHARDA SAHAKARI BANK",
     "ifsc": "IBKL0776SPS"
    },
    {
     "name": "SARASPUR NAGARIK CO-OP BANK",
     "ifsc": "GSCB0USNCBL"
    },
    {
     "name": "THE SARDARGANJ MERCANTILE CO-OP BANK",
     "ifsc": "UTIB0SSMC01"
    },
    {
     "name": "SARVODAYA CO-OP BANK",
     "ifsc": "IBKL0443SCC"
    },
    {
     "name": "SARVODAYA SAHAKARI BANK",
     "ifsc": "YESB0SSBL01"
    },
    {
     "name": "SHINHAN BANK",
     "ifsc": "SHBK0000001"
    },
    {
     "name": "SHREE DHARTI CO-OP BANK",
     "ifsc": "YESB0SDB002"
    },
    {
     "name": "SHRI PANCHGANGA NAGARI SAHKARI BANK",
     "ifsc": "IBKL0464PNS"
    },
    {
     "name": "SHREE WARANA SAHAKARI BANK",
     "ifsc": "HDFC0CSWSBL"
    },
    {
     "name": "SHRI ANAND NAGARI SAHAKARI BANK",
     "ifsc": "YESB0SANB99"
    },
    {
     "name": "SHRI ADINATH CO-OP BANK",
     "ifsc": "HDFC0CSACBL"
    },
    {
     "name": "SHRIMANT MALOJIRAJE SAHAKARI BANK",
     "ifsc": "ICIC00SMSBL"
    },
    {
     "name": "SHUSHRUTI SOUAHRDA SAHAKRA BANK",
     "ifsc": "HDFC0CSSSBN"
    },
    {
     "name": "SUNDARLAL SAWJI URBAN CO-OP BANK",
     "ifsc": "SRCB0SSB001"
    },
    {
     "name": "THE AHMEDNAGAR DISTRICT CEN CO-OP BANK",
     "ifsc": "ICIC00ADCCB"
    },
    {
     "name": "THE AURANGABAD DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL01192AC"
    },
    {
     "name": "THE BARDOLI NAGRIK SAHAKARI BANK",
     "ifsc": "GSCB0UTBNBL"
    },
    {
     "name": "THE BARODA CITY CO-OP BANK",
     "ifsc": "KKBK0BCCB04"
    },
    {
     "name": "THE BHAGYALAKSHMI MAHILA SAHAKARI BANK",
     "ifsc": "HDFC0CBLMSB"
    },
    {
     "name": "THE BHAGYODAYA CO-OP BANK",
     "ifsc": "HDFC0CTBCBL"
    },
    {
     "name": "THE BHANDARA DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "YESB0BHN001"
    },
    {
     "name": "BHARUCH DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "GSCB0BRC001"
    },
    {
     "name": "BHAVANA RISHI CO-OP BANK",
     "ifsc": "YESB0BRCB01"
    },
    {
     "name": "THE CHANDRAPUR DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "YESB0CDC016"
    },
    {
     "name": "THE COMMERCIAL CO-OP BANK",
     "ifsc": "HDFC0COMMCO"
    },
    {
     "name": "THE DEOLA MERCHANTS CO-OP BANK",
     "ifsc": "IBKL0157001"
    },
    {
     "name": "FINANCIAL CO-OP BANK",
     "ifsc": "YESB0FINCO2"
    },
    {
     "name": "GODHRA URBAN CO-OP BANK",
     "ifsc": "UTIB0SGUCB1"
    },
    {
     "name": "THE JALGAON DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "ICIC00JDCCB"
    },
    {
     "name": "THE KARNAVATI CO-OP BANK",
     "ifsc": "KKBK0TKCB01"
    },
    {
     "name": "KHAMGAON URBAN CO-OP BANK",
     "ifsc": "HDFC0CKUB01"
    },
    {
     "name": "THE KODUNGALLUR TOWN CO-OP BANK",
     "ifsc": "IBKL0269KTC"
    },
    {
     "name": "THE MADANAPALLE CO-OP TOWN BANK",
     "ifsc": "HDFC0CMPLTB"
    },
    {
     "name": "THE MAHARAJA CO-OP URBAN BANK",
     "ifsc": "IBLK0031MCB"
    },
    {
     "name": "THE MANGALORE CATHOLIC CO-OP BANK",
     "ifsc": "IBKL0078MCC"
    },
    {
     "name": "THE MUSLIM CO-OP BANK",
     "ifsc": "MSLM0000001"
    },
    {
     "name": "THE NAWADA CENTRAL CO-OP BANK",
     "ifsc": "YESBONCCB01"
    },
    {
     "name": "THE OTTAPALAM CO-OP BANK",
     "ifsc": "IBKL0763OCB"
    },
    {
     "name": "PANCHSHEEL CO-OP BANK",
     "ifsc": "YESB0PMCB02"
    },
    {
     "name": "THE RAJKOT COMMERCIAL CO-OP BANK",
     "ifsc": "ICIC00RCCBL"
    },
    {
     "name": "THE RANUJ NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CRANUJ"
    },
    {
     "name": "THE SAMASTIPUR DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL0065SDC"
    },
    {
     "name": "THE SARVODAYA NAGRIK SAHKARI BANK",
     "ifsc": "GSCB0UTSNBL"
    },
    {
     "name": "THE SEVALIA URBAN CO-OP BANK",
     "ifsc": "ICIC00SEVUC"
    },
    {
     "name": "SURAT MERCANTILE CO-OP BANK",
     "ifsc": "YESB0SMCB05"
    },
    {
     "name": "THE UNION CO-OP BANK",
     "ifsc": "HDFC0CUCBNR"
    },
    {
     "name": "THE UTTARSANDA PEOPLES CO-OP BANK",
     "ifsc": "UTIB0SUPCB1"
    },
    {
     "name": "THE VIJAY CO-OP BANK",
     "ifsc": "VCOB0000001"
    },
    {
     "name": "THE WASHIM URBAN CO-OP BANK",
     "ifsc": "HDFC0CWUCBL"
    },
    {
     "name": "THE YAVATMAL URBAN CO-OP BANK",
     "ifsc": "IBKL0041Y01"
    },
    {
     "name": "UNJHA NAGARIK SAHAKARI BANK",
     "ifsc": "GSCB0UUNJBL"
    },
    {
     "name": "UTTRAKHAND CO-OP BANK",
     "ifsc": "HDFC0CUCOBL"
    },
    {
     "name": "VALMIKI URBAN CO-OP BANK",
     "ifsc": "UTIB0SVAUB1"
    },
    {
     "name": "THE VERAVAL MERCANTILE CO-OP BANK",
     "ifsc": "HDFC0CVMCBA"
    },
    {
     "name": "WAI URBAN CO-OP BANK",
     "ifsc": "SVCB0016101"
    },
    {
     "name": "NAGAR SAHKARI BANK",
     "ifsc": "IBKL01064NS"
    },
    {
     "name": "DISTRICT COOPERATIVE BANK (SAHARANPUR)",
     "ifsc": "ICIC00DCBLS"
    },
    {
     "name": "THE BATHINDA CENTRAL CO-OP BANK",
     "ifsc": "UTIB0SBCB01"
    },
    {
     "name": "AHMEDNAGAR SHAHAR SAHAKARI BANK",
     "ifsc": "SVCB0008011"
    },
    {
     "name": "DMK JAOLI BANK",
     "ifsc": "DMKJ0000002"
    },
    {
     "name": "DEHRADUN DISTRICT CO-OP BANK",
     "ifsc": "YESB0DZSB01"
    },
    {
     "name": "GUJARAT AMBUJA CO-OP BANK",
     "ifsc": "GSCB0UGACBL"
    },
    {
     "name": "THE IDUKKI DISTRICT CO-OP BANK",
     "ifsc": "IDUK0000055"
    },
    {
     "name": "INDORE PARASPAR SAHAKARI BANK",
     "ifsc": "ICIC00INPRS"
    },
    {
     "name": "INDORE PREMIER CO-OP BANK",
     "ifsc": "CBIN0MPDCAO"
    },
    {
     "name": "THE JAMPETA CO-OP URBAN BANK",
     "ifsc": "UTIB0SJCUB2"
    },
    {
     "name": "THE UDAIPUR MAHILA SAMRIDHI URBAN CO-OP BANK"
    },
    {
     "name": "TEXTILE TRADERS CO-OP BANK",
     "ifsc": "TTCB0000001"
    },
    {
     "name": "THE NASIK MERCHANTS CO-OP BANK (NAMCO BANK)",
     "ifsc": "NMCB0000002"
    },
    {
     "name": "THE NAVNIRMAN CO-OP BANK",
     "ifsc": "NVNM0000001"
    },
    {
     "name": "THE MAHARASHTRA STATE CO-OP BANK",
     "ifsc": "MSCI0082002"
    },
    {
     "name": "THE BHARAT CO-OP BANK (IDBI)",
     "ifsc": "IBKL0008BCB"
    },
    {
     "name": "RANI CHANNAMMA MAHILA SAHAKARI BANK",
     "ifsc": "IBKL0101BZR"
    },
    {
     "name": "WARDHAMAN URBAN CO-OP BANK",
     "ifsc": "IBKL0510WUC"
    },
    {
     "name": "THE NAVAL DOCKYARD CO-OP BANK",
     "ifsc": "IBKL0452ND1"
    },
    {
     "name": "VARDHAMAN MAHILA CO-OP URBAN BANK",
     "ifsc": "HDFC0CVB004"
    },
    {
     "name": "PRATAP CO-OP BANK",
     "ifsc": "MDCB0680265"
    },
    {
     "name": "SHRI MAHILA SEWA SAHAKARI BANK",
     "ifsc": "HDFC0CSMSSB"
    },
    {
     "name": "MAHATMA FULE DISTRICT URBAN CO-OP BANK",
     "ifsc": "HDFC0CMFUCB"
    },
    {
     "name": "THE TIRUVALLA EAST CO-OP BANK",
     "ifsc": "IBKL0029T03"
    },
    {
     "name": "THE GANDHI CO-OP URBAN BANK",
     "ifsc": "YESB0GCUB01"
    },
    {
     "name": "THE ANAND MERCANTILE CO-OP BANK",
     "ifsc": "HDFC0CAMCBK"
    },
    {
     "name": "NAGRIK SAHAKARI BANK (MARYADHIT VIDISHA)",
     "ifsc": "HDFC0CNSBMV"
    },
    {
     "name": "UDYAM VIKAS SAHAKARI BANK",
     "ifsc": "HDFC0CUDYAM"
    },
    {
     "name": "THE TEXCO CO-OP BANK",
     "ifsc": "YESB0TCB002"
    },
    {
     "name": "UMA CO-OP BANK",
     "ifsc": "YESB0UMA002"
    },
    {
     "name": "SHRI SHIVAYOGI MURUGHENDRA SWAMI URBAN CO-OP BANK",
     "ifsc": "HDFC0CSSMSB"
    },
    {
     "name": "THE SULTANS BATTERY CO-OP URBAN BANK",
     "ifsc": "IBKL01708SB"
    },
    {
     "name": "THE SATARA SAHAKARI BANK",
     "ifsc": "TSSB0000001"
    },
    {
     "name": "SRI RAMA CO-OP BANK",
     "ifsc": "HDFC0CSRCBL"
    },
    {
     "name": "SRI GURU RAGHAVENDRA SAHAKARA BANK",
     "ifsc": "IBKL0868GRS"
    },
    {
     "name": "THE SIRSI URBAN SAHAKARI BANK",
     "ifsc": "IBKL0069S01"
    },
    {
     "name": "NAVANAGARA URBAN CO-OP BANK",
     "ifsc": "HDFC0CNUCBK"
    },
    {
     "name": "SUBHADRA LOCAL AREA BANK",
     "ifsc": "HDFC0CSLABK"
    },
    {
     "name": "PEOPLES CO-OP BANK",
     "ifsc": "HDFC0CPCBLD"
    },
    {
     "name": "PIMPALGOAN MERCHANTS CO-OP BANK",
     "ifsc": "HDFC0CPIMCO"
    },
    {
     "name": "MIZORAM URBAN CO-OP DEVELOPMENT BANK",
     "ifsc": "YESB0MUDC01"
    },
    {
     "name": "VIJAY COMMERCIAL CO-OP BANK",
     "ifsc": "KKBK0VCCB01"
    },
    {
     "name": "THE COOPERATIVE BANK OF MEHSANA",
     "ifsc": "GSCB0UCOBML"
    },
    {
     "name": "AP RAJARAJESWARI MAHILA CO-OP URBAN BANK",
     "ifsc": "UTIB0SAPRR2"
    },
    {
     "name": "PRERANA CO-OP BANK",
     "ifsc": "HDFC0CPRCBL"
    },
    {
     "name": "MAHANAGAR NAGRIK SAHAKARI BANK",
     "ifsc": "YESB0MNSB01"
    },
    {
     "name": "THE MAHAVEER CO-OP BANK",
     "ifsc": "HDFC0CTMCBL"
    },
    {
     "name": "THE THODUPUZHA CO-OP BANK",
     "ifsc": "ICIC00TPZCB"
    },
    {
     "name": "PALUS SAHAKARI BANK",
     "ifsc": "UTIB0SPSB01"
    },
    {
     "name": "URBAN CO-OP BANK (DEHRADUN)",
     "ifsc": "YESB0DUCB01"
    },
    {
     "name": "SADHANA SAHAKARI BANK (NAGPUR)",
     "ifsc": "IBKL0041SSB"
    },
    {
     "name": "MANNDESHI MAHILA SAHAKARI BANK",
     "ifsc": "YESB0MAN001"
    },
    {
     "name": "SMRITI NAGRIK SAHAKARI BANK",
     "ifsc": "SMNB0000002"
    },
    {
     "name": "TIRUPATI URBAN CO-OP BANK",
     "ifsc": "HDFC0CTUB02"
    },
    {
     "name": "THE JAIN SAHKARI BANK",
     "ifsc": "IBKL0452JSB"
    },
    {
     "name": "NOBLE CO-OP BANK",
     "ifsc": "YESB0NCB001"
    },
    {
     "name": "THE GANDHIDHAM MERCANTILE CO-OP BANK",
     "ifsc": "GSCB0UGMCBL"
    },
    {
     "name": "RAILWAY EMPLOYEE CO-OP BANK",
     "ifsc": "UTIB0SRECB1"
    },
    {
     "name": "AMRAVATI ZILLA PARISHAD SHIKSHAK SAHAKARI BANK",
     "ifsc": "YESB0ASSB01"
    },
    {
     "name": "INDRAPRASTHA SEHKARI BANK",
     "ifsc": "UTIB0SIPSB1"
    },
    {
     "name": "THE MERCHANTS SOUHARDA SAHAKARI BANK",
     "ifsc": "UTIB0SMCB51"
    },
    {
     "name": "THE KOLLAM DISTRICT CO-OP BANK",
     "ifsc": "YESB0KLMDCB"
    },
    {
     "name": "ZILA SAHAKARI BANK (ALMORA)",
     "ifsc": "YESB0AZSB01"
    },
    {
     "name": "ZILA SAHAKARI BANK (TEHRI GARHWAL)",
     "ifsc": "IBKL070TGZS"
    },
    {
     "name": "ZILA SAHAKARI BANK (HARIDWAR)",
     "ifsc": "ICIC00ZSBHA"
    },
    {
     "name": "ZILA SAHAKARI BANK (UTTARKASHI)",
     "ifsc": "YESB0DCBU01"
    },
    {
     "name": "ZILA SAHAKARI BANK (AGRA)",
     "ifsc": "ICIC00AGDCB"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (DEWAS)",
     "ifsc": "CBIN0MPDCAJ"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (MORENA)",
     "ifsc": "CBIN0MPDCAV"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (KHANDWA)",
     "ifsc": "CBIN0MPDCAR"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (VIDISHA)",
     "ifsc": "CBIN0MPDCBM"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (UJJAIN)",
     "ifsc": "CBIN0MPDCBL"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (DHAR)",
     "ifsc": "CBIN0MPDCAK"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (HOSHANGABAD)",
     "ifsc": "CBIN0MPDCAN"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (DAMOH)",
     "ifsc": "CBIN0MPDCAH"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (NARSINGHPUR)",
     "ifsc": "CBIN0MPDCAW"
    },
    {
     "name": "SHRI SHIVESHWAR NAGRI SAHAKARI BANK",
     "ifsc": "UTIB0SSSN01"
    },
    {
     "name": "THE KAKINADA CO-OPERATIVE TOWN BANK",
     "ifsc": "UTIB0SKCTBL"
    },
    {
     "name": "KANNUR DISTRICT CO-OP BANK",
     "ifsc": "IBKL0340K01"
    },
    {
     "name": "THE CHANASMA NAGARIK SAHAKARI BANK",
     "ifsc": "GSCB0UCHANA"
    },
    {
     "name": "THE COIMBATORE DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010000"
    },
    {
     "name": "BANGALORE CITY CO-OP BANK",
     "ifsc": "INDB0BCCB02"
    },
    {
     "name": "SHIVA SAHAKARI BANK (NIYAMITA TARIKERE)",
     "ifsc": "UTIB0SSVA01"
    },
    {
     "name": "THE GURUVAYUR CO-OP URBAN BANK",
     "ifsc": "ICIC00GCUBL"
    },
    {
     "name": "THE BHAGAT CO-OP BANK",
     "ifsc": "IBKL0773BCB"
    },
    {
     "name": "THE BICHOLIUM URBAN CO-OP BANK",
     "ifsc": "HDFC0CBUCBG"
    },
    {
     "name": "THE MATTANCHERRY SARVAJANIK CO-OP BANK",
     "ifsc": "KKBK0MSCB01"
    },
    {
     "name": "SARDAR VALLABHBHAI SAHAKARI BANK",
     "ifsc": "HDFC0CSVSBL"
    },
    {
     "name": "AGRASEN CO-OP URBAN BANK",
     "ifsc": "HDFC0CAUB01"
    },
    {
     "name": "SRI GOKARNATH CO-OP BANK",
     "ifsc": "IBKL0078GOK"
    },
    {
     "name": "THE JAMKHANDI URBAN CO-OP BANK",
     "ifsc": "ICIC00TJUCB"
    },
    {
     "name": "BALASINOR NAGRIK SAHKARI BANK",
     "ifsc": "HDFC0CBNSBL"
    },
    {
     "name": "SHREE MURUGHARAJENDRA CO-OP BANK",
     "ifsc": "UTIB0SSMCBL"
    },
    {
     "name": "KODINAR TALUKA CO-OP BANKING UNION",
     "ifsc": "GSCB0KDT001"
    },
    {
     "name": "SHIMSHA SAHAKARA BANK"
    },
    {
     "name": "KODAGU CENTRAL CO-OP BANK",
     "ifsc": "KSCB0011001"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (RAJGRAH)",
     "ifsc": "CBIN0MPDCAZ"
    },
    {
     "name": "NAGRIK SAHKARI BANK (GWALIOR)",
     "ifsc": "INDB0NSBG01"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (RAIPUR)",
     "ifsc": "UTIB0JSBR01"
    },
    {
     "name": "JUNAGADH JILLA SAHAKARI BANK",
     "ifsc": "GSCB0JND001"
    },
    {
     "name": "SHIVA SAHAKARI BANK (NIYAMITA DAVANA)",
     "ifsc": "UTIB0SSBDVG"
    },
    {
     "name": "AKOLA URBAN CO-OP BANK",
     "ifsc": "YESB0AUBHO1"
    },
    {
     "name": "LONAVALA SAHAKARI BANK",
     "ifsc": "HDFC0CLSABL"
    },
    {
     "name": "VIDYASAGAR CENTRAL CO-OP BANK",
     "ifsc": "WBSC0VCCB27"
    },
    {
     "name": "THE YAVATMAL DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "UTIB0SYDC01"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (JHABUA)",
     "ifsc": "CBIN0MPDCAQ"
    },
    {
     "name": "KHALILABAD NAGAR SAH BANK",
     "ifsc": "YESB0KHBKMW"
    },
    {
     "name": "DISTRICT COOPERATIVE BANK (FAIZABAD)",
     "ifsc": "ICIC00FDCCB"
    },
    {
     "name": "DISTRICT COOPERATIVE BANK (MORADABAD)",
     "ifsc": "ICIC00MORAD"
    },
    {
     "name": "THE NIZAMABAD DISTRICT CO-OP CENTRAL BANK",
     "ifsc": "TSAB0018018"
    },
    {
     "name": "SHRI BALAJI URBAN CO-OP BANK"
    },
    {
     "name": "SHREYAS GRAMIN BANK",
     "ifsc": "CNRB000SGB7"
    },
    {
     "name": "UNITED MERC CO-OP BANK",
     "ifsc": "YESB0UMCBRP"
    },
    {
     "name": "RAE BARELI DISTRICT CO-OP BANK"
    },
    {
     "name": "THE BHIWANI CENTRAL CO-OP BANK",
     "ifsc": "UTIB0BHIW01"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (BHIND)",
     "ifsc": "CBIN0MPDCAD"
    },
    {
     "name": "ERODE DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010800"
    },
    {
     "name": "SARAKARI NAUKARARA SAHAKARI BANK",
     "ifsc": "UTIB0SSNSBK"
    },
    {
     "name": "KOLHAPUR DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL0463KDC"
    },
    {
     "name": "LOKNETE DATTAJI PATIL SAHKARI BANK",
     "ifsc": "IBKL01992L1"
    },
    {
     "name": "THE MANDVI NAGRIK SAHAKARI BANK",
     "ifsc": "GSCB0UTMNBL"
    },
    {
     "name": "HANAMASAGAR URBAN CO-OP BANK",
     "ifsc": "UTIB0SHUCBL"
    },
    {
     "name": "SRI SUDHA CO-OP BANK",
     "ifsc": "HDFC0CSUDHA"
    },
    {
     "name": "THE BHUJ COMMERCIAL CO-OP BANK",
     "ifsc": "UTIB0BCCB01"
    },
    {
     "name": "SHRI BHARAT URBAN CO-OP BANK",
     "ifsc": "HDFC0CBHRAT"
    },
    {
     "name": "SREE CHARAN SOUH CO-OP BANK"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (DURG)",
     "ifsc": "UTIB0SJSD01"
    },
    {
     "name": "SANMITRA MAHILA NAGARI SAHAKARI BANK",
     "ifsc": "HDFC0CSMNSB"
    },
    {
     "name": "THE MAHARASHTRA MANTRALAYA AND ALLIED OFFICES CO-OP BANK",
     "ifsc": "IBKL0004MCB"
    },
    {
     "name": "INDRAYANI CO-OP BANK",
     "ifsc": "HDFC0CICBLP"
    },
    {
     "name": "COLOUR MERCHANTS CO-OP BANK",
     "ifsc": "HDFC0CCMCBL"
    },
    {
     "name": "SHREE BASAVESHWAR URBAN CO-OP BANK",
     "ifsc": "UTIB0SBUBRN"
    },
    {
     "name": "ILKAL COOPERATIVE BANK",
     "ifsc": "UTIB0SICB25"
    },
    {
     "name": "SADALGA URBAN SOUHARDA SAHAKARI BANK",
     "ifsc": "UTIB0SSUSSB"
    },
    {
     "name": "THE GANDHIDHAM CO-OPERATIVE BANK",
     "ifsc": "HDFC0CGCBLG"
    },
    {
     "name": "CHIKMAGALUR JILLA MAHILA SAHAKARA BANK",
     "ifsc": "UTIB0SCJMSB"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (GUNA)",
     "ifsc": "CBIN0MPDCAL"
    },
    {
     "name": "SHILLONG COOPERATIVE URBAN BANK",
     "ifsc": "IBKL0158SCU"
    },
    {
     "name": "THE BELLARY DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "IBKL0103901"
    },
    {
     "name": "SHRI CHATRAPATI SHIVAJI MAHARAJ SAHAKARI BANK",
     "ifsc": "UTIB0SCSMSB"
    },
    {
     "name": "THE CO-OP BANK OF RAJKOT",
     "ifsc": "YESB0RAJ001"
    },
    {
     "name": "SREENIDHI SOUHARDA SAHAKARI BANK",
     "ifsc": "INDB0SSBN01"
    },
    {
     "name": "DURGAPUR STEEL PEOPLES CO-OP BANK",
     "ifsc": "DURG0000001"
    },
    {
     "name": "BELLAD BAGEWADI URBAN SOUHARDA SAHAKARI BANK",
     "ifsc": "IBKL0101BBU"
    },
    {
     "name": "THE GODHRA CITY CO-OP BANK",
     "ifsc": "HDFC0CGCCB1"
    },
    {
     "name": "THE SOLAPUR DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "YESB0SDC001"
    },
    {
     "name": "SHRI LAXMIKRUPA URBAN CO-OP BANK",
     "ifsc": "HDFC0CSLKUB"
    },
    {
     "name": "MEWAR AANCHALIK GRAMIN BANK",
     "ifsc": "ICIC00MEWAR"
    },
    {
     "name": "SANGLI SAHAKARI BANK",
     "ifsc": "UTIB0SSSB05"
    },
    {
     "name": "CHIKMAGALUR PATTANA SAHAKARA BANK",
     "ifsc": "UTIB0SCPSBN"
    },
    {
     "name": "VEERASHAIVA SAHAKARI BANK",
     "ifsc": "HDFC0CVSBHO"
    },
    {
     "name": "MUMBAI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "MDCB0680035"
    },
    {
     "name": "SHREE SAMARTH SAHAKARI BANK",
     "ifsc": "HDFC0CSSBNK"
    },
    {
     "name": "THE DAHOD MERCANTILE CO-OP BANK",
     "ifsc": "HDFC0CDMCBD"
    },
    {
     "name": "THE SAHEBRAO DESHMUKH CO-OP BANK",
     "ifsc": "SAHE0000001"
    },
    {
     "name": "THE KANYAKUMARI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010300"
    },
    {
     "name": "THE KUMBAKONAM CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010400"
    },
    {
     "name": "THE THOOTHUKUDI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0012100"
    },
    {
     "name": "THE TIRUNELVELI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011500"
    },
    {
     "name": "THE VILLUPURAM DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0012200"
    },
    {
     "name": "JANATHA SEVA CO-OP BANK",
     "ifsc": "JTSC0000001"
    },
    {
     "name": "VASAI JANATA SAHAKARI BANK",
     "ifsc": "VASJ0000001"
    },
    {
     "name": "VYAVSAYIK SAHAKARI BANK",
     "ifsc": "YESB0VSBL02"
    },
    {
     "name": "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK",
     "ifsc": "CRLY0000002"
    },
    {
     "name": "DAUSA URBAN COOPERATIVE BANK",
     "ifsc": "UTIB0SDUCB3"
    },
    {
     "name": "VIKRAMADITYA NAGRIK SAHAKARI BANK",
     "ifsc": "YESB0VNSB01"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (SAGAR)",
     "ifsc": "CBIN0MPDCBC"
    },
    {
     "name": "RAJSAMAND URBAN CO-OP BANK",
     "ifsc": "YESB0RUCB05"
    },
    {
     "name": "SHRI KRISHNA CO-OP BANK",
     "ifsc": "SVCB0037002"
    },
    {
     "name": "URBAN CO-OP BANK (BASTI)",
     "ifsc": "YESB0URBAN1"
    },
    {
     "name": "THE GUNTUR CO-OP URBAN BANK",
     "ifsc": "UTIB0SGUB02"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (SEHORE)",
     "ifsc": "CBIN0MPDCBE"
    },
    {
     "name": "ACE CO-OP BANK",
     "ifsc": "IBKL0100ACB"
    },
    {
     "name": "THE BABASAHEB DESHMUKH SAHAKARI BANK",
     "ifsc": "IBKL0467BDS"
    },
    {
     "name": "SAMATA CO-OP DEVELOPMENT BANK",
     "ifsc": "HDFC0CSAMAT"
    },
    {
     "name": "JILA SAHAKARI KENDRIYA BANK (BALAGHAT)",
     "ifsc": "CBIN0MPDCAB"
    },
    {
     "name": "THE ASTHA PEOPLES CO-OP BANK",
     "ifsc": "IBKL0116APC"
    },
    {
     "name": "AMRELI NAGRIK SAHKARI BANK",
     "ifsc": "IBKL0697ANS"
    },
    {
     "name": "INDIAN MERCANTILE CO-OP BANK",
     "ifsc": "YESB0IMRC01"
    },
    {
     "name": "SHIVAJI NAGARI SAHAKARI BANK",
     "ifsc": "ICIC00SHNSB"
    },
    {
     "name": "SHREE MAHUVA NAGRIK SAHKARI BANK",
     "ifsc": "HDFC0CMNSAA"
    },
    {
     "name": "HCBL CO-OP BANK",
     "ifsc": "YESB0HCBL01"
    },
    {
     "name": "THE JANATA CO-OP BANK",
     "ifsc": "HDFC0CTJCBL"
    },
    {
     "name": "THE VAISHALI DISTRICT CENTRAL CO-​OP BANK",
     "ifsc": "IBKL0724VDC"
    },
    {
     "name": "SARDAR SINGH NAGRIK SAHAKARI BANK",
     "ifsc": "HDFC0CSSNSB"
    },
    {
     "name": "BARAN NAGRIK SAHKARI BANK",
     "ifsc": "HDFC0CBNB01"
    },
    {
     "name": "SHRIRAM URBAN CO-OP BANK",
     "ifsc": "KKBK0SUCB01"
    },
    {
     "name": "THE AGRASEN NAGARI SAHAKARI BANK",
     "ifsc": "HDFC0CTANSB"
    },
    {
     "name": "UP POSTAL PRIMARY CO-OP BANK",
     "ifsc": "ICIC00PPCBL"
    },
    {
     "name": "PALGHAT CO-OP URBAN BANK",
     "ifsc": "UTIB0PKDU97"
    },
    {
     "name": "THE SALEM DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011100"
    },
    {
     "name": "THE MADURAI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010600"
    },
    {
     "name": "THE RAMANATHAPURAM DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011000"
    },
    {
     "name": "THE THANJAVUR CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011300"
    },
    {
     "name": "THE VIRUDHUNAGAR DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011800"
    },
    {
     "name": "THE KANCHIPURAM CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010200"
    },
    {
     "name": "THE NILGIRIS DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0010700"
    },
    {
     "name": "THE SIVAGANGAI DISTRICT CENTRAL CO-OP BANK",
     "ifsc": "TNSC0011900"
    },
    {
     "name": "JIJAU COMMERCIAL CO-OP BANK",
     "ifsc": "IBKL0JCB001"
    },
    {
     "name": "SRI KANYAKAPARAMESWARI CO-OP BANK",
     "ifsc": "UTIB0SSKPCB"
    },
    {
     "name": "SHAHADA PEOPLES CO-OP BANK",
     "ifsc": "YESB0SPCB01"
    },
    {
     "name": "DELHI NAGRIK SEHKARI BANK",
     "ifsc": "YESB0DNB014"
    },
    {
     "name": "SHREE MAHALAXMI URBAN CO-OP CREDIT BANK",
     "ifsc": "SVCB0012002"
    },
    {
     "name": "ARVIND SAHAKARI BANK"
    },
    {
     "name": "THE WOMENS CO-OP BANK",
     "ifsc": "IBKL0546WCB"
    },
    {
     "name": "THE PANVEL URBAN CO-OP BANK",
     "ifsc": "IBKL0189PUC"
    },
    {
     "name": "WANA NAGRIK SAHAKARI BANK",
     "ifsc": "YESB0WANA01"
    },
    {
     "name": "THE BIJNOR URBAN CO-OP BANK",
     "ifsc": "HDFC0CBUCBL"
    },
    {
     "name": "ABHINAV SAHKARI BANK"
    },
    {
     "name": "THE VSV CO-OP BANK",
     "ifsc": "HDFC0CVSVCB"
    },
    {
     "name": "THE URBAN CO-OP BANK",
     "ifsc": "URBN00000B1"
    },
    {
     "name": "PRAGATI MAHILA NAGRIK SAHAKARI BANK",
     "ifsc": "YESB0PMNSB1"
    },
    {
     "name": "SREE MAHAYOGI LAKSHMAMMA CO-OP BANK",
     "ifsc": "UTIB0SAVB01"
    },
    {
     "name": "DISTRICT COOPERATIVE BANK (MEDAK)",
     "ifsc": "TSAB0017001"
    },
    {
     "name": "THE KARIMNAGAR DISTRICT CO-OP CENTRAL BANK",
     "ifsc": "TSAB0020001"
    },
    {
     "name": "MAHALAKSHMI CO-OP BANK (UDUPI)",
     "ifsc": "IBKL0186MC2"
    },
    {
     "name": "GUARDIAN BANK",
     "ifsc": "SVCB0002001"
    },
    {
     "name": "INDORE CLOTH MARKET CO-OP BANK",
     "ifsc": "YESB0ICMB02"
    },
    {
     "name": "SRIRAMANAGAR PATTANA SAHAKARA BANK",
     "ifsc": "IBKL01543SR"
    },
    {
     "name": "NANDANI SAHAKARI BANK",
     "ifsc": "HDFC0CNSBLN"
    },
    {
     "name": "THE IDAR NAGARIK SAHAKARI BANK",
     "ifsc": "GSCB0UIDARB"
    },
    {
     "name": "JOGINDRA CENTRAL CO-OP BANK",
     "ifsc": "YESB0JCCB01"
    },
    {
     "name": "ABASAHEB PATIL RENDAL SAHAKARI BANK",
     "ifsc": "IBKL0116RSB"
    },
    {
     "name": "KOILKUNTLA CO-OP BANK",
     "ifsc": "INDB0KCBL01"
    },
    {
     "name": "THE KOPARGAON PEOPLES CO-OP BANK",
     "ifsc": "SVCB0035002"
    },
    {
     "name": "WARANGAL URBAN CO-OP BANK",
     "ifsc": "YESB0WUCB02"
    },
    {
     "name": "SHREE MAHESH CO-OP BANK (NASHIK)",
     "ifsc": "YESB0SMBLHO"
    },
    {
     "name": "RAJADHANI CO-OP URBAN BANK",
     "ifsc": "KKBK0RCUB01"
    },
    {
     "name": "RESERVE BANK EMPLOYEES CO-OP BANK",
     "ifsc": "INDB0RBECBL"
    },
    {
     "name": "GODAVARI URBAN CO-OP BANK (NASHIK)",
     "ifsc": "HDFC0CGCB01"
    },
    {
     "name": "DHULE VIKAS SAHAKARI BANK",
     "ifsc": "ICIC00DVSBL"
    },
    {
     "name": "CONTAI CO-OP BANK",
     "ifsc": "ICIC00CCBLT"
    },
    {
     "name": "ARIHANT URBAN CO-OP BANK",
     "ifsc": "HDFC0CACOBL"
    },
    {
     "name": "THE KHAMMAM DISTRICT CO-OP CENTRAL BANK",
     "ifsc": "TSAB0022001"
    },
    {
     "name": "THE KAPURTHALA CENTRAL CO-OP BANK",
     "ifsc": "UTIB0SKPT01"
    },
    {
     "name": "ZILA SAHKARI BANK (MUZAFFARNAGAR)",
     "ifsc": "UPCB00MUZAF"
    },
    {
     "name": "SHIVALIK SMALL FINANCE BANK",
     "ifsc": "SMCB0001001"
    },
    {
     "name": "APPASAHEB BIRNALE SAHAKARI BANK",
     "ifsc": "SVCB0055003"
    },
    {
     "name": "NALGONDA DISTRICT CO-OP CENTRAL BANK",
     "ifsc": "TSAB0023001"
    },
    {
     "name": "THE KHORDHA CENTRAL CO-OP BANK",
     "ifsc": "ORCB0KHU001"
    },
    {
     "name": "THE BHAGALPUR CENTRAL CO-OP BANK",
     "ifsc": "IBKL0721BCC"
    }
   ]